<ng-container *ngIf="init$ | async">
    <app-kratka-povijest-promjena></app-kratka-povijest-promjena>
    <p-accordion [(activeIndex)]="activeIndex">
        <p-accordionTab header="Događaji">
            <ng-container *ngIf="activeIndex===0">
                <ng-container *ngIf="currentViewState" ntapDynamicFormProvider>
                    <ng-container ntapFilterViewProvider [viewName]="currentViewName"
                        [viewState]="currentViewStateFilter">
                        <ng-container ntapListViewProvider [viewName]="currentViewName" [viewState]="currentViewState">
                            <ntap-dynamic [compId]="INIT_COMP_ID"></ntap-dynamic>
                        </ng-container>
                    </ng-container>
                </ng-container>
            </ng-container>
        </p-accordionTab>
    </p-accordion>
</ng-container>